import './SiteFooter.css';

export function SiteFooter({ onNavigate }) {
    return (
        <footer className="siteFooter">
            <div className="siteFooterInner">
                <div className="siteFooterTop">
                    <div className="siteFooterBrand">
                        <span className="siteFooterLogo">Pornoclaw</span>
                        <span className="siteFooterTag">AI photo & video generator · 2026</span>
                    </div>
                    <div className="siteFooterLinks">
                        {onNavigate && <>
                            <button className="siteFooterLink" onClick={() => onNavigate('terms')}>Terms</button>
                            <button className="siteFooterLink" onClick={() => onNavigate('privacy')}>Privacy</button>
                            <button className="siteFooterLink" onClick={() => onNavigate('payment')}>Payment rules</button>
                            <button className="siteFooterLink" onClick={() => onNavigate('compliance')}>2257</button>
                            <button className="siteFooterLink" onClick={() => onNavigate('contact')}>Contact</button>
                            <button className="siteFooterLink" onClick={() => onNavigate('report')}>Report content</button>
                        </>}
                    </div>
                </div>

                <div className="siteFooterLegal">
                    <p className="siteFooterLine">
                        This website is operated by Hotmate Ltd, Giannou Kranidioti &amp; Pargas, 9, office 102, Nicosia, 1065, Cyprus.
                    </p>
                    <p className="siteFooterLine">
                        If you have any complaints or concerns, you may contact us at{' '}
                        <a href="mailto:complains@hotmate.ai">complains@hotmate.ai</a>. Any submission will receive a
                        response and be resolved within a reasonable timeframe, typically within 7 business days.
                    </p>
                </div>
            </div>
        </footer>
    );
}
